import styles from "../css/invoice.module.css";

export default function InvoiceHeader({ consultationData }) {
  const patient = consultationData?.patient || {};
  const patientName = `${patient.firstname || ""} ${patient.surname || ""}`.trim() || "Patient";
  
  return (
    <>
      <h1 className={styles.title}>Invoice</h1>
      <p className={styles.subtitle}>
        Consolidated invoice for {patientName}'s visit
      </p>
    </>
  );
}
